import { Icon } from "~/common/components/icon/Icon";
import { IconType } from "~/common/components/icon/IconType";
import { ActionTextLinkCell } from "~/features/search/components/ProductResults/views/TabularView/ProductTabularViewActionCell/ProductTabularViewActionCell";

export const OpenCalcAction = ({ url, ...rest }: { url?: string }) => (
  <ActionTextLinkCell className={!url ? "v-hidden" : ""} href={url} target={"_blank"} {...rest}>
    <Icon type={IconType.Calculator} />
  </ActionTextLinkCell>
);
